export const redirectUserToNewRefundService = (invoiceID: string, type: string) => {
  const baseUrl = process.env.REACT_APP_REFUND_SERVICE_URL;

  window.location.href = `${baseUrl}/refund-request?invoiceID=${invoiceID}&type=${type}`;
};
